import React, { useState, useEffect } from "react";
import Grid from '@material-ui/core/Grid';
import Box from '@material-ui/core/Box';
import Skeleton from '@material-ui/lab/Skeleton';
import Hidden from '@material-ui/core/Hidden';
import InfoContainer from "./container/InfoContainer";
import ReactImageFallback from "react-image-fallback";
import { Translation } from 'react-i18next';
import { Link } from 'react-router-dom';
import styles from './inventory.module.css';
import characterMap from "../json/characters";
import inventoryMissingImg from "../images/inventory_missing.png";

import {
    generatePageURI,
    CDN_URI_BASE,
    CDN_URI,
    pagePaths
} from "../common/utilities";

export default class IndexInventory extends React.Component{

	constructor(props){
        super(props);

	    this.state = {
            outputList: []
            ,contentReady: false
        }
    }

    componentDidUpdate(){
        if(this.state.contentReady){
            //alert('content is ready');
        }
    }


    getImgUrl(data){

        //console.log('ITEM_CODE', data.ITEM_CODE);
        //console.log('ITEM_ID',data.ITEM_ID);
        //console.log('ITEM_CATEGORY',data.ITEM_CATEGORY);

        var weaponFolder = 'web/inventory/weapons/300_169/';
        var charactersFolder = 'web/inventory/characters/300_169/';
        var namecardsFolder = 'web/inventory/namecards/300_169/';
        var spraysFolder = 'web/inventory/sprays/300_169/';
        var costumesFolder = 'web/inventory/costumes/300_169/';
        var placeholder = inventoryMissingImg;
        var itemImg = null;

        var category = (data && data.ITEM_CATEGORY) ? data.ITEM_CATEGORY : null;
        var itemCode = (data && data.ITEM_CODE) ? data.ITEM_CODE : null;
        var itemID = (data && data.ITEM_ID) ? data.ITEM_ID : null;
        var charImg = (characterMap[itemID] && characterMap[itemID].IMG_NAME) ? characterMap[itemID].IMG_NAME : null;

        switch (category) {
            case 1: //weapon
              itemImg = CDN_URI_BASE + weaponFolder + itemCode + '.png';
              break;

            case 2: //character
              itemImg = CDN_URI_BASE + charactersFolder + itemCode + '.png';
              break;

            case 3: //name card
              itemImg = CDN_URI_BASE + namecardsFolder + itemCode + '.png';
              break;

            case 4: //spray
              itemImg = CDN_URI_BASE + spraysFolder + itemCode + '.png';
              break;

            case 5: //costume
              itemImg = CDN_URI_BASE + costumesFolder + itemCode + '.png';
              break;
          }

        return (
                <ReactImageFallback
                    src={itemImg}
                    fallbackImage={placeholder}
                    alt="inventory img"
                />
        );
    }

    InventorySkeleton(){
        return (
            <div style={{width: '180px'}}>
                <Skeleton variant="rect" width="180px" height="90px" />
            </div>
        );
    }

    // display collections
    showData(){

        // profile index page only allows 8
        var maxOutput = 8;
        maxOutput = (this.props.userInventory.length && this.props.userInventory.length <= maxOutput ) ? this.props.userInventory.length : maxOutput;

        var string = [];
        let vipIconClass = '';

        for(var i = 0; i< maxOutput; i++){

            vipIconClass = (this.props.userInventory[i].VIP_FLAG) ? ' icon-vip' : '';

            var output =<div key={i} className={styles.item_container + vipIconClass}>
                            {this.getImgUrl(this.props.userInventory[i])}
                            <h3>
                                {this.props.userInventory[i].DISPLAY_NAME}
                            </h3>
                        </div>

            var itemContainer = null;

            switch (i) {
                case 0: case 1: itemContainer = <Grid item xs={12} sm={6} md={3} lg={3} xl={3} key={Math.random(i)}>{output}</Grid>; break;
                case 2: case 3: itemContainer = <Grid item xs={12} sm={6} md={3} lg={3} xl={3} key={Math.random(i)}><Hidden smDown>{output}</Hidden></Grid>; break;
                case 4: case 5: itemContainer = <Grid item xs={12} sm={6} md={3} lg={3} xl={3} key={Math.random(i)}><Hidden mdDown>{output}</Hidden></Grid>; break;
                case 6: case 7: itemContainer = <Grid item xs={12} sm={6} md={3} lg={3} xl={3} key={Math.random(i)}><Hidden mdDown>{output}</Hidden></Grid>; break;
            };

            string.push(itemContainer);
            // */
        }

        return string;
    }


    render (){

        // var headerTitle = 'Inventory';
        var headerTitle = (
        <Translation>
            {
            (t) => (
                <Link to={generatePageURI(pagePaths.INVENTORY)}>
                    {t('Inventory')}
                </Link>
            )
            }
        </Translation>
        );

        var showMoreLink = (
            <Translation>
            {
            (t) => (
                <Link
                    to={generatePageURI(
                        pagePaths.INVENTORY
                        )}
                    >
                        {t('See Full Inventory')}
                    </Link>
            )
            }
            </Translation>
        );


        if(this.props.counts){

            var dataChild =  <div className={styles.inventory}>
                                        <Grid container spacing={1}>
                                            {this.showData()}
                                        </Grid>
                                    </div>

            return (
                <Grid item>
                    <InfoContainer
                        headerLeft = {headerTitle}
                        headerRight = {this.props.counts[0].CNT + ' Items'}
                        footer ={showMoreLink}
                        children = {dataChild}
                        />
                </Grid>
            );
        }else{
            return (
                <Grid item>
                    <InfoContainer
                        headerLeft = {headerTitle}
                        headerRight = {null}
                        footer ={showMoreLink}
                        children = {this.InventorySkeleton()}
                        />
                </Grid>
            );
        }
    }
}